import { useEffect, useState } from "react";
import axios from "axios";
import config from "./config";

/**
 * Inline banner ad(s) — rendered in the page flow (e.g. below the banner).
 */
function InlineBanner({ token, groupToken, placement = "community_page", wrapperClass = "max-w-6xl mx-auto px-4 mt-5 space-y-3" }) {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    let active = true;
    axios
      .post(`${config.COMMUNITY_API_URL}/community-banners`, {
        community_token: token,
        group_token: groupToken,
        placement,
      })
      .then((res) => {
        if (active && res.data?.error === 0) setAds(res.data.inline || []);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [token, groupToken, placement]);

  if (ads.length === 0) return null;

  return (
    <div className={wrapperClass}>
      {ads.map((b) => {
        const img = (
          <img src={b.image} alt="" className="w-full rounded-xl border shadow-sm block" />
        );
        return b.link ? (
          <a key={b.id} href={b.link} target="_blank" rel="noreferrer" className="block">
            {img}
          </a>
        ) : (
          <div key={b.id}>{img}</div>
        );
      })}
    </div>
  );
}

export default InlineBanner;
